import React, { useCallback, useState } from "react";
import { Issue } from "@adsk/acc-issues-types";
import { DeleteButton } from "../utils/components/DeleteButton";
import { useTranslations } from "@adsk/acc-issues-translations";
import { IssueBulkDeleteConfirmation } from "./IssueBulkDeleteConfirmation";
import { getPermissionsForBulkEdit } from "./bulkEditPermissions";
import { IssueBulkDeleteConfirmationOpenedFrom } from "./IssueBulkDeleteConfirmationOpenedFrom";
import { trackBulkDeleteClickEvent } from "../utils/analytics/issueDeletionTracking";
import { useWatcherPropName } from "../utils/hooks/watchers/useWatcherPropName";

export const IssueBulkDeleteButton = ({
  issues,
  onSuccessfulDeletion,
}: {
  issues: Issue[];
  onSuccessfulDeletion?: () => void;
}) => {
  const { T } = useTranslations();
  const deleteButtonLabel = T.translate("issueTable.bulkDelete", {
    selectedCount: issues.length,
  });
  const watcherProp = useWatcherPropName();
  const { canDeleteAllSelectedIssues } = getPermissionsForBulkEdit({
    issues,
    watcherProp,
  });
  const [isDeleteConfirmationModalOpen, setIsDeleteConfirmationModalOpen] =
    useState(false);

  const onBulkDeleteClick = useCallback(() => {
    setIsDeleteConfirmationModalOpen(true);
    trackBulkDeleteClickEvent({ numberOfIssues: issues.length });
  }, [issues]);

  return (
    <>
      <DeleteButton
        disabled={!canDeleteAllSelectedIssues}
        disabledReason={T.translate("noPermissions")}
        label={deleteButtonLabel}
        onClick={onBulkDeleteClick}
      />
      <IssueBulkDeleteConfirmation
        issueUids={issues.map(issue => issue.id)}
        onClose={() => {
          setIsDeleteConfirmationModalOpen(false);
        }}
        isOpen={isDeleteConfirmationModalOpen}
        openedFrom={IssueBulkDeleteConfirmationOpenedFrom.TopBar}
        onSuccessfulDeletion={onSuccessfulDeletion}
      />
    </>
  );
};
